export function isRegularSeasonComplete(row) {
  if (typeof row.regular_season_complete === "boolean") {
    return row.regular_season_complete;
  }

  // Older cached payloads have no completion flag. Require a full schedule.
  const year = Number(row.year);
  if (!Number.isFinite(year) || year > new Date().getFullYear()) return false;
  const seasonLength = Number(row.regular_season_length ?? (year < 2021 ? 13 : 14));
  const games = Number(row.regular_wins ?? 0)
    + Number(row.regular_losses ?? 0)
    + Number(row.regular_ties ?? 0);
  return seasonLength > 0 && games >= seasonLength;
}
